/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Islamic_Religion22Inputs */

const en__field_enum_subject_islamic_religion22 = /** @type {(inputs: _Field_Enum_Subject_Islamic_Religion22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islamic Religion`)
};

const de__field_enum_subject_islamic_religion22 = /** @type {(inputs: _Field_Enum_Subject_Islamic_Religion22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islamische Religion`)
};

/**
* | output |
* | --- |
* | "Islamic Religion" |
*
* @param {_Field_Enum_Subject_Islamic_Religion22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_islamic_religion22 = /** @type {((inputs?: _Field_Enum_Subject_Islamic_Religion22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Islamic_Religion22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_islamic_religion22(inputs)
	return de__field_enum_subject_islamic_religion22(inputs)
});
export { _field_enum_subject_islamic_religion22 as "_field_enum_SUBJECT_ISLAMIC_RELIGION" }